// Loop Subscriptions bundles in the cart (markup: snippets/cart-bundle.liquid).
// - <cart-bundle-remove> removes every line of one bundle in a single request.
// - Loop's bundle page adds to cart with its own request the theme doesn't know about,
//   so we watch for cart adds carrying `_bundleId` and re-render + open the drawer.

async function renderCartDrawer(isEmpty) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const sections = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`).then((r) => r.json());
  drawer.renderContents({ sections });
  drawer.classList.toggle('is-empty', isEmpty);
  drawer.querySelector('.drawer-inner')?.classList.toggle('is-empty', isEmpty);
}

class CartBundleRemove extends HTMLElement {
  connectedCallback() {
    this.querySelector('button').addEventListener('click', () => this.removeBundle());
  }

  async removeBundle() {
    this.querySelector('button').disabled = true;
    const updates = Object.fromEntries(
      this.dataset.keys.split(',').filter(Boolean).map((key) => [key, 0])
    );
    const cart = await fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    }).then((r) => r.json());

    // Cart page re-renders by reload, same as the theme's own onCartUpdate.
    if (document.querySelector('cart-items')) return window.location.reload();
    renderCartDrawer(cart.item_count === 0);
  }
}
customElements.define('cart-bundle-remove', CartBundleRemove);

const isBundleAdd = (url, body) =>
  /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && typeof body === 'string' && body.includes('_bundleId');

const nativeFetch = window.fetch;
window.fetch = async (input, init) => {
  const response = await nativeFetch(input, init);
  if (response.ok && isBundleAdd(input?.url ?? input, init?.body)) renderCartDrawer(false);
  return response;
};

const nativeOpen = XMLHttpRequest.prototype.open;
const nativeSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._cartBundleUrl = url;
  return nativeOpen.call(this, method, url, ...rest);
};
XMLHttpRequest.prototype.send = function (body) {
  if (isBundleAdd(this._cartBundleUrl, body)) {
    this.addEventListener('load', () => this.status < 400 && renderCartDrawer(false));
  }
  return nativeSend.call(this, body);
};
